import React, { useState } from "react";
// import { CompactPicker } from "react-color";
import ProfileForm from "./ProfileForm";

const NewReport = (props) => {
  const [pageState, setPageState] = useState("Loading");
  const [prevInput, setInput] = useState({});

  function getIName() {
    let AP = props.activeProfile.Name;
    AP = AP.replaceAll(" ", "_");
    return AP + "_Inputs";
  }

  function CheckState() {
    if (LoadIncomplete() === undefined || LoadIncomplete() === null) {
      setPageState("Loaded");
    } else {
      setPageState("Choosing");
    }
  }
  function LoadWithInputs() {
    setInput(JSON.parse(LoadIncomplete()));
    setPageState("Loaded");
  }
  function LoadNormal() {
    setPageState("Loaded");
  }
  function LoadFromLocal() {
    let textVals = localStorage.getItem(getIName());
    //console.log(textVals);
    return textVals;
  }
  function LoadIncomplete() {
    //todo input a switch for loading from local storage or database.
    return LoadFromLocal();
  }

  if (pageState === "Loading") {
    CheckState();
  }

  if (pageState === "Choosing") {
    return (
      <div>
        <h3>
          You have incomplete form data from before, how would you like to
          proceed?
        </h3>
        <div className="NewProfileButtonArea">
          <div className="divButton" onClick={LoadWithInputs}>
            Load Previous Data
          </div>
          <div className="divButton" onClick={LoadNormal}>
            Start over <br />
            (Erase pervious Data)
          </div>
        </div>
      </div>
    );
  }
  if (pageState === "Loaded") {
    //console.log(prevInput);
    return (
      <ProfileForm
        QDB={props.QDB}
        user={props.user}
        userKey={props.userKey}
        email={props.user.attributes.email}
        profileData={props.profileData}
        activeProfile={props.activeProfile}
        getIName={getIName}
        prevInput={prevInput}
        Dev={props.Dev}
      ></ProfileForm>
    );
  }
};

export default NewReport;
